import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
export function template() {
  const disabled = this.attr(`disabled`);
  const on = this.attr(`on`);
  const icon = this.attr(`icon`) ? this.attr(`icon`) : `checkmark`;
  const showcase = this.attr(`showcase`) && !on && !disabled;
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-switch",
    class: {
      "switch-on": on,
      "switch-off": !on,
      showcase,
      disabled
    },
    on: {
      click: disabled ? null : this.helpers.toggleSwitch
    }
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon },
    class: { "show-icon-while-off": this.attr(`show-icon-while-off`) }
  }));
}
